import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { rootReducer } from "./reducers";
import thunk from "redux-thunk";

import Mainpage from "./pages/Mainpage";

const persistedState = localStorage.getItem("store")
  ? JSON.parse(localStorage.getItem("store"))
  : {};

const store = createStore(
  rootReducer,
  persistedState,
  composeWithDevTools(applyMiddleware(thunk))
);

store.subscribe(() => {
  localStorage.setItem(
    "STORE_DETAIL",
    JSON.stringify({
      cartDetail: store.getState().cartDetail,
    })
  );
  localStorage.setItem(
    "USER_DETAIL",
    JSON.stringify({
      userDetail: store.getState().adminDetail,
    })
  );
});

function App() {
  return (
    <>
      <Mainpage />
    </>
  );
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
